import { faEnvelope } from '@fortawesome/free-regular-svg-icons'

import IconButton from '@/components/IconButton'
import RequestsSidebar from '@/components/Requests'
import type { Applicant } from '@/lib/apollo/query/get-applicant'
import type { Application } from '@/types/Activity'
import { isRefCompleted } from '@/utils/subjectHelpers'

interface Props {
  applicant: Applicant
  application: Application
  disabled?: boolean
  isOpen: boolean
  setOpen: (open: boolean) => void
}

const Requests = ({
  applicant,
  application,
  disabled = false,
  isOpen,
  setOpen,
}: Props) => {
  return (
    <>
      {isOpen && (
        <RequestsSidebar
          setOpen={setOpen}
          subjectData={{
            applicationId: applicant.applicationId,
            customerId: applicant.customerId,
            subjectId: applicant.id,
            email: applicant.email,
            name: applicant.fullName,
            financial: application.context?.financial,
            isRefCompleted: isRefCompleted(application),
            incomes: application.context?.incomes ?? [],
          }}
        />
      )}
      <IconButton
        tooltipMessage="Requests"
        icon={faEnvelope}
        disabled={disabled}
        onClick={() => setOpen(!isOpen)}
      />
    </>
  )
}

export default Requests
